import { createReducer, on } from '@ngrx/store';
import { companyStateDataType } from '../../core/models/Interfaces/company';
import {
  addAddress,
  addAddressFailed,
  addAddressSuccessfull,
  addCityPermits,
  addCityPermitsFailed,
  addCityPermitsSuccessfull,
  addContacts,
  addContactsSuccessfull,
  addInsurancePolicy,
  addInsurancePolicyFailed,
  addInsurancePolicySuccessfull,
  companyDataSubmit,
  companyDataSubmitFailed,
  companyDataSubmitReceived,
  companyOwnerCities,
  companyOwnerCitiesFailed,
  companyOwnerCitiesReceived,
  deleteAddress,
  deleteAddressFailed,
  deleteAddressSuccessfull,
  deleteCityPermits,
  deleteCityPermitsFailed,
  deleteCityPermitsSuccessfull,
  deleteContacts,
  deleteContactsFailed,
  deleteContactsSuccessfull,
  deleteInsurancePolicy,
  deleteInsurancePolicyFailed,
  deleteInsurancePolicySuccessfull,
  editAddress,
  editAddressFailed,
  editAddressSuccessfull,
  editCityPermits,
  editCityPermitsFailed,
  editCityPermitsSuccessfull,
  editContacts,
  editContactsFailed,
  editContactsSuccessfull,
  editInsurancePolicy,
  editInsurancePolicyFailed,
  editInsurancePolicySuccessfull,
  fetchCompanyData,
  fetchCompanyDataFailed,
  fetchCompanyDataSuccessful,
  getAddress,
  getAddressFailed,
  getAddressReceived,
  getCityPermits,
  getCityPermitsFailed,
  getCityPermitsReceived,
  getComments,
  getCommentsFailed,
  getCommentsReceived,
  getContacts,
  getContactsReceived,
  getInsurancePolicy,
  getInsurancePolicyFailed,
  getInsurancePolicyReceived,
  getUnviewedCount,
  getUnviewedCountFailed,
  getUnviewedCountReceived,
} from '../actions/companyAction';

const initialState: companyStateDataType = {
  isSubmittingCompanyRecord: false,
  isCompanyRecordSuccess: false,
  companyDetails: null,
  isCompanyRecordFailed: false,
  userCompanyData: null,
  userCompanyDataFetchingFailed: false,
  userCompanyDataFetching: false,
  companyOwnerCities: null,
  isFetchingOwnerCities: false,
  isOwnerCitiesSuccess: false,
  isOwnerCitiesFailed: false,
  addContactsSubmitting: false,
  fetchingContacts: false,
  contactsData: null,
  editContactsSubmitting: false,
  deleteContactsSubmitting: false,
  addressData: null,
  isFetchingAddress: false,
  addAddressSubmitting: false,
  editAddressSubmitting: false,
  deleteAddressSubmitting: false,
  isFetchingComments: false,
  commentsData: null,
  isFetchingVehicles: false,
  vehiclesData: null,
  isFetchingCityPermits: false,
  cityPermitsData: null,
  addCityPermitsSubmitting: false,
  editCityPermitsSubmitting: false,
  isFetchingInsurancePolicy: false,
  insurancePolicyData: null,
  addInsurancePolicySubmitting: false,
  editInsurancePolicySubmitting: false,
  deleteCityPermitsSubmitting: false,
  deleteInsurancePolicySubmitting: false,
  unviewedCountData: null,
};

export const companyReducer = createReducer(
  initialState,
  on(companyDataSubmit, (state) => {
    return { ...state, isSubmittingCompanyRecord: true };
  }),
  on(companyDataSubmitReceived, (state, { data }: any) => {
    return {
      ...state,
      isSubmittingCompanyRecord: false,
      companyDetails: data,
      isCompanyRecordSuccess: true,
      isCompanyRecordFailed: false,
    };
  }),
  on(companyDataSubmitFailed, (state) => {
    return {
      ...state,
      isSubmittingCompanyRecord: false,
      companyDetails: null,
      isCompanyRecordFailed: true,
      isCompanyRecordSuccess: false,
    };
  }),

  on(fetchCompanyData, (state) => {
    return { ...state, userCompanyData: null, userCompanyDataFetching: true };
  }),
  on(fetchCompanyDataSuccessful, (state, data) => {
    return {
      ...state,
      userCompanyData: data?.params,
      userCompanyDataFetchingFailed: false,
      userCompanyDataFetching: false,
    };
  }),
  on(fetchCompanyDataFailed, (state) => {
    return {
      ...state,
      userCompanyData: null,
      userCompanyDataFetchingFailed: true,
      userCompanyDataFetching: false,
    };
  }),

  on(companyOwnerCities, (state) => {
    return { ...state, isFetchingOwnerCities: true };
  }),
  on(companyOwnerCitiesReceived, (state, data) => {
    return {
      ...state,
      isFetchingOwnerCities: false,
      companyOwnerCities: data?.params,
      isOwnerCitiesSuccess: true,
      isOwnerCitiesFailed: false,
    };
  }),
  on(companyOwnerCitiesFailed, (state) => {
    return {
      ...state,
      isFetchingOwnerCities: false,
      companyOwnerCities: null,
      isOwnerCitiesFailed: true,
      isOwnerCitiesSuccess: false,
    };
  }),

  on(getContacts, (state) => {
    return { ...state, fetchingContacts: true };
  }),
  on(getContactsReceived, (state, data) => {
    return { ...state, fetchingContacts: false, contactsData: data.params };
  }),

  on(addContacts, (state) => {
    return { ...state, addContactsSubmitting: true };
  }),
  on(addContactsSuccessfull, (state) => {
    return { ...state, addContactsSubmitting: false };
  }),

  on(editContacts, (state) => {
    return { ...state, editContactsSubmitting: true };
  }),
  on(editContactsSuccessfull, (state) => {
    return { ...state, editContactsSubmitting: false };
  }),
  on(editContactsFailed, (state) => {
    return { ...state, editContactsSubmitting: false };
  }),

  on(deleteContacts, (state) => {
    return { ...state, deleteContactsSubmitting: true };
  }),
  on(deleteContactsSuccessfull, (state) => {
    return { ...state, deleteContactsSubmitting: false };
  }),
  on(deleteContactsFailed, (state) => {
    return { ...state, deleteContactsSubmitting: false };
  }),

  on(getAddress, (state) => {
    return { ...state, isFetchingAddress: true };
  }),
  on(getAddressReceived, (state, data) => {
    return { ...state, isFetchingAddress: false, addressData: data.params };
  }),
  on(getAddressFailed, (state) => {
    return { ...state, isFetchingAddress: false };
  }),

  on(addAddress, (state) => {
    return { ...state, addAddressSubmitting: true };
  }),
  on(addAddressSuccessfull, (state) => {
    return { ...state, addAddressSubmitting: false };
  }),
  on(addAddressFailed, (state) => {
    return { ...state, addAddressSubmitting: false };
  }),

  on(editAddress, (state) => {
    return { ...state, editAddressSubmitting: true };
  }),
  on(editAddressSuccessfull, (state) => {
    return { ...state, editAddressSubmitting: false };
  }),
  on(editAddressFailed, (state) => {
    return { ...state, editAddressSubmitting: false };
  }),

  on(deleteAddress, (state) => {
    return { ...state, deleteAddressSubmitting: true };
  }),
  on(deleteAddressSuccessfull, (state) => {
    return { ...state, deleteAddressSubmitting: false };
  }),
  on(deleteAddressFailed, (state) => {
    return { ...state, deleteAddressSubmitting: false };
  }),

  on(getComments, (state) => {
    return { ...state, isFetchingComments: true };
  }),
  on(getCommentsReceived, (state, data) => {
    return { ...state, isFetchingComments: false, commentsData: data?.params };
  }),
  on(getCommentsFailed, (state) => {
    return { ...state, isFetchingComments: false };
  }),

  on(getCityPermits, (state) => {
    return { ...state, isFetchingCityPermits: true };
  }),
  on(getCityPermitsReceived, (state, data) => {
    return {
      ...state,
      isFetchingCityPermits: false,
      cityPermitsData: data?.params,
    };
  }),
  on(getCityPermitsFailed, (state) => {
    return { ...state, isFetchingCityPermits: false };
  }),

  on(addCityPermits, (state) => {
    return { ...state, addCityPermitsSubmitting: true };
  }),
  on(addCityPermitsSuccessfull, (state) => {
    return { ...state, addCityPermitsSubmitting: false };
  }),
  on(addCityPermitsFailed, (state) => {
    return { ...state, addCityPermitsSubmitting: false };
  }),

  on(editCityPermits, (state) => {
    return { ...state, editCityPermitsSubmitting: true };
  }),
  on(editCityPermitsSuccessfull, (state) => {
    return { ...state, editCityPermitsSubmitting: false };
  }),
  on(editCityPermitsFailed, (state) => {
    return { ...state, editCityPermitsSubmitting: false };
  }),

  on(deleteCityPermits, (state) => {
    return { ...state, deleteCityPermitsSubmitting: true };
  }),
  on(deleteCityPermitsSuccessfull, (state) => {
    return { ...state, deleteCityPermitsSubmitting: false };
  }),
  on(deleteCityPermitsFailed, (state) => {
    return { ...state, deleteCityPermitsSubmitting: false };
  }),

  on(getInsurancePolicy, (state) => {
    return { ...state, isFetchingInsurancePolicy: true };
  }),
  on(getInsurancePolicyReceived, (state, data) => {
    return {
      ...state,
      isFetchingInsurancePolicy: false,
      insurancePolicyData: data?.params,
    };
  }),
  on(getInsurancePolicyFailed, (state) => {
    return { ...state, isFetchingInsurancePolicy: false };
  }),

  on(addInsurancePolicy, (state) => {
    return { ...state, addInsurancePolicySubmitting: true };
  }),
  on(addInsurancePolicySuccessfull, (state) => {
    return { ...state, addInsurancePolicySubmitting: false };
  }),
  on(addInsurancePolicyFailed, (state) => {
    return { ...state, addInsurancePolicySubmitting: false };
  }),

  on(editInsurancePolicy, (state) => {
    return { ...state, editInsurancePolicySubmitting: true };
  }),
  on(editInsurancePolicySuccessfull, (state) => {
    return { ...state, editInsurancePolicySubmitting: false };
  }),
  on(editInsurancePolicyFailed, (state) => {
    return { ...state, editInsurancePolicySubmitting: false };
  }),

  on(deleteInsurancePolicy, (state) => {
    return { ...state, deleteInsurancePolicySubmitting: true };
  }),
  on(deleteInsurancePolicySuccessfull, (state) => {
    return { ...state, deleteInsurancePolicySubmitting: false };
  }),
  on(deleteInsurancePolicyFailed, (state) => {
    return { ...state, deleteInsurancePolicySubmitting: false };
  }),

  on(getUnviewedCount, (state) => {
    return { ...state };
  }),
  on(getUnviewedCountReceived, (state, data) => {
    return { ...state, unviewedCountData: data?.params };
  }),
  on(getUnviewedCountFailed, (state) => {
    return { ...state };
  }),
);
